import Cookies from 'universal-cookie';
import { COOKIE_KEY } from '../constants';
const getAccessToken = cookieString => {
  const cookies = cookieString ? new Cookies(cookieString) : new Cookies();
  return cookies.get(COOKIE_KEY) || null;
};
export default getAccessToken;
//# sourceMappingURL=get-access-token.js.map